<template>
  <b-card >

  <div class="d-flex justify-content-between align-items-center mb-2">
    <h3 class="mb-0">Histórico</h3>

    <div class="d-flex align-items-center">

      <b-form-input
        v-model="filters.search"
        placeholder="Buscar CPF/CNPJ ou nome..."
        size="sm"
        class="mr-2"
        style="width: 300px;"
      />

    <div class="position-relative mr-2">

      <b-button
        :variant="hasActiveFilters ? 'primary' : 'outline-transparent'"
        size="sm"
        @click="showFilter = true"
        v-b-tooltip.hover
        title="Filtrar"
      >
        <i class="fas fa-filter"></i>
      </b-button>

      <b-badge
        v-if="activeFiltersCount"
        variant="danger"
        class="position-absolute"
        style="top: -5px; right: -5px;"
      >
        {{ activeFiltersCount }}
      </b-badge>

    </div>

    </div>
  </div>

    <b-table
      :items="filteredHistory"
      :current-page="currentPage"
      :per-page="perPage"
      :fields="fields"
      striped
      hover
      small
      responsive
      show-empty
    >
      <template #empty>
      <div class="text-center text-muted py-3">
        <i class="fas fa-search mb-2" style="font-size: 24px;"></i>
        <p class="mb-0">
          Nenhum registro encontrado para os filtros informados.
        </p>
      </div>
    </template>

    <template #cell(document)="data">
      {{ data.item.document | tax_id }}
    </template>

      <template #cell(created_at)="data">
        {{ data.item.created_at | date }}
      </template>
      <template #cell(active)="data">
        <span
          :class="data.item.active ? 'text-success' : 'text-danger'"
        >
          {{ data.item.active ? 'Ativo' : 'Inativo' }}
        </span>
      </template>

      <template #cell(type)="data">
        <b-badge :variant="data.item.type === 'PJ' ? 'primary' : 'secondary'">
          {{ data.item.type }}
        </b-badge>
      </template>
    </b-table>

     <b-pagination
    v-model="currentPage"
     :total-rows="filteredHistory.length"
     :per-page="perPage"
      align="center"
      size="sm"
      class="my-1"
    />

    <BlacklistFilterModal
    :show="showFilter"
    :filters="filters"
    @close="showFilter = false"
    @apply="handleFilters"
  />
  </b-card>
</template>

<script>
import { BCard, BTable, BBadge, BButton, BFormInput, BPagination } from 'bootstrap-vue'
import BlacklistFilterModal from './components/BlacklistFilterModal.vue'

export default {
  components: {
    BCard,
    BTable,
    BBadge,
    BFormInput,
    BButton,
    BPagination,
    BlacklistFilterModal
  },

  data() {
    
    return {
    currentPage: 1,
    perPage: 10,
    showFilter: false,
    filters: {
      search: '',
      type: '',
      source: '',
      reason: '',
    },
      fields: [
        { key: 'created_at', label: 'Data de Inclusão', tdClass: 'text-center', sortable: true},
        { key: 'type', label: 'tipo' },
        { key: 'document', label: 'Documento' },
        { key: 'name', label: 'Nome', sortable: true},
        { key: 'reason', label: 'Motivo' },
        { key: 'source', label: 'Fonte' },
      ],

    }
  },

  props: {
    history: {
      type: Array,
      default: () => []
    }
  },

computed: {
  filteredHistory() {
    const filtered = this.history.filter(item => {
      const f = this.filters

      const search = f.search.toLowerCase().trim()

      const documentSearch = f.search.replace(/\D/g, '')
      const documentItem = item.document.replace(/\D/g, '')

      const matchesSearch =
        !search ||
        item.name.toLowerCase().includes(search) ||
        (documentSearch && documentItem.includes(documentSearch))

      const matchesType =
        !f.type || item.type === f.type

      const matchesSource =
        !f.source || item.source === f.source

      const matchesReason =
        !f.reason ||
        item.reason.toLowerCase().includes(f.reason.toLowerCase())

      return (
        matchesSearch &&
        matchesType &&
        matchesSource &&
        matchesReason
      )
    })

    return filtered.sort((a, b) => {
      return new Date(b.created_at) - new Date(a.created_at)
    })
  },

  activeFiltersCount() {
    const f = this.filters

    return [
      f.search,
      f.type,
      f.source,
      f.reason,
    ].filter(Boolean).length
  },

  hasActiveFilters() {
    return this.activeFiltersCount > 0
  }
},
  methods: {
    handleFilters(newFilters) {
      this.filters = newFilters
    }
  }
}
</script>